(() => {
  const root = document.querySelector('[data-lds-badge-product]');
  if (!root) return;
  const form = root.querySelector('[data-lds-badge-form]');
  const node = root.querySelector('[data-lds-badge-variants]');
  if (!form || !node) return;
  const variants = JSON.parse(node.textContent || '[]');
  const groups = [...root.querySelectorAll('[data-lds-option-index]')];
  const variantInput = form.querySelector('[data-lds-variant-id]');
  const requestBox = form.querySelector('[data-lds-custom-request]');
  const requestField = requestBox?.querySelector('textarea');
  const status = form.querySelector('[data-lds-status]');
  const add = form.querySelector('[data-lds-add]');
  const stickyAdd = root.querySelector('[data-lds-sticky-add]');
  const money = cents => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents, root.dataset.moneyFormat || '${{amount}}') : new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' }).format(Number(cents) / 100);
  const purchaseRules = document.getElementById(`LdsPurchaseRules-${root.dataset.productId}`);
  const purchasePanel = window.LdsPurchasePanel?.install(root, { form, formatMoney: money, quantityRules: purchaseRules ? JSON.parse(purchaseRules.textContent) : undefined });
  const selections = () => groups.map(group => group.querySelector('[data-lds-option-value][aria-pressed="true"]')?.dataset.ldsOptionValue || '');
  const selected = values => variants.find(variant => Array.isArray(variant.options) && variant.options.length === values.length && variant.options.every((value, index) => value === values[index]));
  const variantOptions = variant => Array.isArray(variant?.options) ? variant.options : [];
  const selectedById = id => variants.find(variant => String(variant.id) === String(id));
  const updateButtons = values => groups.forEach((group, index) => group.querySelectorAll('[data-lds-option-value]').forEach(choice => {
    const active = choice.dataset.ldsOptionValue === values[index];
    choice.classList.toggle('is-selected', active);
    choice.setAttribute('aria-pressed', String(active));
  }));
  const variantUrl = id => {
    const url = new URL(window.location.href);
    if (id) url.searchParams.set('variant', id);
    else url.searchParams.delete('variant');
    return `${url.pathname}${url.search}${url.hash}`;
  };
  const writeVariantUrl = (variant, mode) => {
    if (!variant?.id || mode === false) return;
    const current = new URL(window.location.href).searchParams.get('variant');
    if (String(current || '') === String(variant.id)) return;
    const next = variantUrl(variant.id);
    if (mode === 'replace') history.replaceState({ variant: String(variant.id) }, '', next);
    else if (mode === 'push') history.pushState({ variant: String(variant.id) }, '', next);
  };
  const update = (historyMode = false) => {
    const values = selections();
    const variant = selected(values);
    const custom = values.includes('Custom Logo');
    if (requestBox) requestBox.hidden = !custom;
    if (requestField) {
      requestField.disabled = !custom;
      requestField.required = custom;
      requestField.setCustomValidity('');
    }
    if (variantInput) {
      variantInput.value = variant?.id || '';
      variantInput.disabled = !variant;
    }
    const price = variant ? money(variant.price) : 'Unavailable';
    root.querySelector('[data-lds-price]')?.replaceChildren(document.createTextNode(price));
    root.querySelector('[data-lds-sticky-price]')?.replaceChildren(document.createTextNode(price));
    const stickySummary = root.querySelector('[data-lds-sticky-summary]');
    if (stickySummary) stickySummary.textContent = values.join(' / ');
    if (add) {
      add.textContent = variant ? `Add to cart · ${price}` : 'Unavailable';
      add.disabled = !variant?.available;
    }
    if (stickyAdd) stickyAdd.disabled = !variant?.available;
    if (status) status.textContent = !variant ? 'This combination is unavailable.' : variant.available ? '' : 'This option is unavailable.';
    purchasePanel?.render(variant, Boolean(variant?.available));
    writeVariantUrl(variant, historyMode);
    variantInput?.dispatchEvent(new Event('change', { bubbles: true }));
  };
  groups.forEach(group => group.addEventListener('click', event => {
    const button = event.target.closest('[data-lds-option-value]');
    if (!button || !group.contains(button)) return;
    group.querySelectorAll('[data-lds-option-value]').forEach(choice => { const active = choice === button; choice.classList.toggle('is-selected', active); choice.setAttribute('aria-pressed', String(active)); });
    update('push');
  }));
  stickyAdd?.addEventListener('click', () => form.requestSubmit(add));
  form.addEventListener('submit', event => {
    if (!selected(selections())) { event.preventDefault(); if (status) status.textContent = 'Select an available badge option.'; return; }
    if (requestField && !requestField.disabled && !requestField.value.trim()) { event.preventDefault(); requestField.setCustomValidity('Please describe the logo or text for this badge.'); requestField.reportValidity(); requestField.focus(); return; }
    requestField?.setCustomValidity('');
    if (requestField && !requestField.disabled) requestField.value = requestField.value.trim();
  });
  requestField?.addEventListener('input', () => requestField.setCustomValidity(''));

  const slides = [...root.querySelectorAll('[data-lds-slide]')];
  const thumbs = [...root.querySelectorAll('[data-lds-thumb]')];
  let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
  const show = (next, scrollThumb = true) => {
    if (!slides.length) return;
    const previous = slides[index];
    previous?.querySelectorAll('video').forEach(video => video.pause());
    previous?.querySelectorAll('iframe').forEach(frame => { const src = frame.src; frame.src = src; });
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    thumbs.forEach((thumb, i) => { thumb.classList.toggle('is-active', i === index); thumb.setAttribute('aria-current', String(i === index)); });
    const current = root.querySelector('[data-lds-current]');
    if (current) current.textContent = String(index + 1);
    if (scrollThumb) thumbs[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };
  if (root.hasAttribute('data-lds-camry-pilot')) root.addEventListener('lds:badge-color-main', () => show(0, false));
  root.querySelector('[data-lds-prev]')?.addEventListener('click', () => show(index - 1));
  root.querySelector('[data-lds-next]')?.addEventListener('click', () => show(index + 1));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  const anchorNav = root.querySelector('[data-lds-badge-anchor-nav]');
  if (anchorNav) {
    const links = [...anchorNav.querySelectorAll('a[href^="#"]')];
    const headerBottom = () => Math.max(0, ...[...document.querySelectorAll('header')].map(header => header.getBoundingClientRect()).filter(rect => rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight).map(rect => rect.bottom));
    const measure = () => {
      const offset = Math.ceil(headerBottom());
      root.style.setProperty('--lds-v2-nav-offset', `${offset}px`);
      document.documentElement.style.setProperty('--lds-badge-anchor-offset', `${offset + anchorNav.getBoundingClientRect().height + 16}px`);
    };
    const followHash = () => {
      const target = links.find(link => link.hash === window.location.hash);
      if (!target) return;
      const element = document.getElementById(target.hash.slice(1));
      if (!element) return;
      measure();
      const top = Math.max(0, window.scrollY + element.getBoundingClientRect().top - headerBottom() - anchorNav.getBoundingClientRect().height - 16);
      window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    links.forEach(link => link.addEventListener('click', event => {
      if (!document.getElementById(link.hash.slice(1))) return;
      event.preventDefault();
      const url = new URL(window.location.href);
      url.hash = link.hash;
      history.pushState({}, '', `${url.pathname}${url.search}${url.hash}`);
      followHash();
    }));
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', () => { measure(); if (window.location.hash) followHash(); }, { once: true });
    window.addEventListener('hashchange', followHash);
  }
  window.addEventListener('popstate', () => {
    const requestedVariant = selectedById(new URL(window.location.href).searchParams.get('variant'));
    if (requestedVariant) updateButtons(variantOptions(requestedVariant));
    update(false);
  });
  update('replace');
})();
